// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"a179574a","611":"e6b7e7f7"}[chunkId] + ".chunk.js";
};